"use client";
import { Box, BoxProps } from "@chakra-ui/react";
import { forwardRef } from "react";

export type WrapperProps = BoxProps;

/**
 * No `forwardRef` required on this
 * Useful for the `CurrentLocationSearchOption` component
 */
export const SearchOptionWrapper = ({ children, ...rest }: WrapperProps) => (
  <Box
    display="flex"
    alignItems="center"
    minH="16"
    mt="2"
    px="4"
    py="2"
    rounded="lg"
    bg="gray.50"
    color="blueGray.800"
    _selected={{
      bg: "blue.500",
      color: "white",
      mark: {
        color: "white",
        textDecoration: "underline",
      },
    }}
    {...rest}
  >
    {children}
  </Box>
);

export const Wrapper = forwardRef<HTMLDivElement, WrapperProps>(
  (props: WrapperProps, ref) => {
    const { children, ...rest } = props;
    return (
      <Box
        ref={ref}
        display="flex"
        alignItems="center"
        minH="16"
        mt="2"
        px="4"
        py="2"
        rounded="lg"
        bg="gray.50"
        color="blueGray.800"
        _selected={{
          bg: "blue.500",
          color: "white",
          mark: {
            color: "white",
            textDecoration: "underline",
          },
        }}
        {...rest}
      >
        {children}
      </Box>
    );
  },
);
